import { mediaUrl } from '@/components/Player/mediaUrl.js';

/*
 * The placeholder portraits are owned by the backend, not by this bundle.
 *
 * `CharacterCreator` picks one when it creates a biography, and
 * `CharacterBiography.avatar` defaults to `other.png`. The frontend fallback
 * has to name the SAME files, or a character whose avatar row is fine but whose
 * file failed to load would swap to a picture the server would never have
 * chosen for it.
 *
 * There are two sets. The pathed set — `placeholder/{json,john}/<gender>.png` —
 * is what a character actually gets, because the order they swore to is the one
 * irreversible choice creation makes and the stand-in should show it. The
 * pathless set — `placeholder/<gender>.png` — still exists because
 * `create_character` runs before a path is chosen, and because most callers
 * here are error fallbacks that know a gender and nothing else.
 *
 * Mirrors:
 *   dx_backend/apps/game/services/character/placeholder_avatar.py
 *   dx_backend/apps/character/models/player.py (avatar default)
 *
 * Keep this and that in step; it is the only copy on the client.
 */
export const AVATAR_PLACEHOLDER_DIR = 'media/avatars/placeholder';

export const AVATAR_PLACEHOLDER_FILE_BY_GENDER = Object.freeze({
  Male: 'male.png',
  Female: 'female.png',
  Other: 'other.png',
});

export const DEFAULT_AVATAR_PLACEHOLDER_FILE = 'other.png';

/* The two orders, named as the asset directories are. `pathFlavour.flavourOf`
   turns a path row into one of these. */
export const AVATAR_PLACEHOLDER_FLAVOURS = Object.freeze(['json', 'john']);

export function avatarPlaceholderFile(gender) {
  if (typeof gender !== 'string') return DEFAULT_AVATAR_PLACEHOLDER_FILE;
  return (
    AVATAR_PLACEHOLDER_FILE_BY_GENDER[gender.trim()] ??
    DEFAULT_AVATAR_PLACEHOLDER_FILE
  );
}

export function avatarPlaceholderPath(gender, flavour) {
  const file = avatarPlaceholderFile(gender);
  return AVATAR_PLACEHOLDER_FLAVOURS.includes(flavour)
    ? `${AVATAR_PLACEHOLDER_DIR}/${flavour}/${file}`
    : `${AVATAR_PLACEHOLDER_DIR}/${file}`;
}

export function avatarPlaceholderUrl(gender, flavour) {
  return mediaUrl(avatarPlaceholderPath(gender, flavour));
}
